import React from 'react';
import { cn } from '@/utils/cn';

export interface WorkspaceHeaderProps {
  title: React.ReactNode;
  /** Right-aligned controls (refresh, history menu...). Use <IconButton size="sm">. */
  actions?: React.ReactNode;
  className?: string;
}

/** The strip at the top of every workspace panel (cards view, note, draft, workflow). */
export const WorkspaceHeader: React.FC<WorkspaceHeaderProps> = ({ title, actions, className }) => (
  <div className={cn('flex flex-shrink-0 items-center justify-between gap-2 border-b border-ui-border px-4 py-1.5', className)}>
    <h2 className="eyebrow truncate text-ui-text2">{title}</h2>
    {actions && <div className="flex shrink-0 items-center gap-1">{actions}</div>}
  </div>
);

export default WorkspaceHeader;
